// extracted by mini-css-extract-plugin
export default {"container":"service-cards_container__eE4+0","title":"service-cards_title__xIpsE","cards":"service-cards_cards__VQO4P"};